function SkeletonLine({ width = '100%', height = 10, className = '' }) {
  return (
    <div
      className={`dash-skeleton-line ${className}`.trim()}
      style={{ width, height }}
    />
  );
}

export function KpiGridSkeleton({ columns = 'g10', count = 10 }) {
  return (
    <div className={columns}>
      {Array.from({ length: count }, (_, index) => (
        <div className="dash-skeleton-kpi" key={`kpi-skeleton-${index}`}>
          <div className="dash-skeleton-kpi-top">
            <SkeletonLine width="55%" height={8} />
            <div className="dash-skeleton-icon" />
          </div>
          <SkeletonLine width="40%" height={22} />
          <SkeletonLine width="70%" height={8} />
        </div>
      ))}
    </div>
  );
}

export function DonutAnalysisSkeleton() {
  return (
    <div className="card-body">
      <div className="donut-wrap">
        <div className="dash-skeleton-donut" />
        <div style={{ flex: 1 }}>
          <div className="dash-skeleton-legend">
            {Array.from({ length: 4 }, (_, index) => (
              <SkeletonLine key={`legend-${index}`} width={90} height={12} />
            ))}
          </div>
          {Array.from({ length: 4 }, (_, index) => (
            <div className="bar-row" key={`bar-${index}`}>
              <div className="bar-meta">
                <SkeletonLine width="35%" height={12} />
                <SkeletonLine width={24} height={12} />
              </div>
              <div className="bar-track">
                <div className="dash-skeleton-bar-fill" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export function ChartSkeleton({ height = 190 }) {
  return (
    <div className="card-body">
      <div className="dash-skeleton-chart" style={{ height }} />
    </div>
  );
}

export function ProgressAnalysisSkeleton({ barCount = 4, chartHeight = 130 }) {
  return (
    <div className="card-body">
      {Array.from({ length: barCount }, (_, index) => (
        <div className="bar-row" key={`progress-bar-${index}`}>
          <div className="bar-meta">
            <SkeletonLine width="30%" height={12} />
            <SkeletonLine width="22%" height={12} />
          </div>
          <div className="bar-track">
            <div className="dash-skeleton-bar-fill" />
          </div>
        </div>
      ))}
      <div className="dash-skeleton-chart" style={{ height: chartHeight, marginTop: 8 }} />
    </div>
  );
}

export function FunnelSkeleton({ stepCount = 4 }) {
  return (
    <div className="funnel">
      {Array.from({ length: stepCount }, (_, index) => (
        <div className="dash-skeleton-funnel-step" key={`funnel-${index}`}>
          <SkeletonLine width="50%" height={22} />
          <SkeletonLine width="70%" height={10} />
        </div>
      ))}
    </div>
  );
}

export function TableSkeleton({ rows = 5, columns = 5 }) {
  return (
    <div className="tbl-wrap dash-skeleton-table-wrap">
      <table>
        <thead>
          <tr>
            {Array.from({ length: columns }, (_, index) => (
              <th key={`head-${index}`}>
                <SkeletonLine width="70%" height={8} />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }, (_, rowIndex) => (
            <tr key={`row-${rowIndex}`}>
              {Array.from({ length: columns }, (_, colIndex) => (
                <td key={`cell-${rowIndex}-${colIndex}`}>
                  <SkeletonLine
                    width={colIndex === 0 ? '80%' : '55%'}
                    height={12}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
